import React from "react";
import { View, Text, ViewProps, StyleSheet } from "react-native";
import { useCurrentDate } from "../hooks/useCurrentDate";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { errorReporting } from "../helpers/errorReporting";
import { ErrorBoundary } from "react-error-boundary";

type CurrentDateTimeProps = ViewProps & { compact?: boolean };

const makeStyles = (theme: ThemeOptions, compact: boolean) =>
  StyleSheet.create({
    dateTimeContainer: {
      justifyContent: "center",
      paddingLeft: theme.spacing.small,
      alignItems: "flex-start",
    },
    timeText: {
      color: theme.backgroundText,
      fontSize: compact ? theme.fontSize.h3 : theme.fontSize.h2,
      fontWeight: "bold",
      lineHeight: compact ? theme.fontSize.h3 : theme.fontSize.h2,
    },
    dateText: {
      color: theme.backgroundText,
      fontSize: compact ? theme.fontSize.body : theme.fontSize.h4,
    },
  });

export const CurrentDateTime = (props: CurrentDateTimeProps) => {
  return (
    <ErrorBoundary
      onError={(error, data) => {
        errorReporting.sendMessage(`CurrentDateTime: ${error.message}`, data);
      }}
      fallbackRender={() => null}
    >
      <CurrentDateTimeInner {...props} />
    </ErrorBoundary>
  );
};

const CurrentDateTimeInner = ({
  compact = false,
  ...props
}: CurrentDateTimeProps) => {
  const styles = makeStyles(useTheme(), compact);
  const { date, time } = useCurrentDate();

  return (
    <View style={styles.dateTimeContainer} {...props}>
      <Text style={styles.timeText}>{time}</Text>
      <Text style={styles.dateText}>{date}</Text>
    </View>
  );
};
